import { FC } from 'react';
import { Box, Skeleton } from '@chakra-ui/react';

export const ContractListSkeleton: FC = () => (
  <Box m="30px 0 0 0">
    <Skeleton h="40px" />
    <Skeleton h="200px" m="20px 0 0 0" />
  </Box>
);
